// Central place for all outbound links used across the blocked-paywall modals.
// Moved here so swapping any of these out (e.g. replacing the Google Form with
// a first-party route) only needs one edit.

// "Learn More Here" — dedicated explainer covering the free plan, weekly
// teaching sessions, and School Plan Trials.
export const LEARN_MORE_URL = '/school-and-free-plan';

// "Fill out this form to get help" — Google Form for school-plan interest.
export const INTEREST_FORM_URL = 'https://forms.gle/1aQGQhfPe9nqVNbV8';

// Curriculum-alignment lead Typeform — the same one used on the curriculum
// landing pages (e.g. BluebonnetLandingContent). Used by the curriculum add-on
// paywall variant so users already on the school plan request the add-on here.
export const CURRICULUM_TYPEFORM_URL = 'https://9uq31r57i3q.typeform.com/to/oyTyfiVe';

// "See plans and pricing" — international path to pricing.
export const PRICING_URL = '/pricing';
